import { environment } from '@environment';

export const activitiesApi = {
  search: `${environment.api.services}/api/travel-intermediary-ms/travel-extra/search`,
  filters: `${environment.api.services}/api/travel-proxy-ms/travel-extra/filter`,
  detail: `${environment.api.services}/api/travel-proxy-ms/travel-extra/detail`,
};
